<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="action-card">
          <div class="action-buttons">
            <el-button
              type="primary"
              size="medium"
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              <span>新增问答分类</span>
            </el-button>
          </div>
        </div>

        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <el-form-item label="分类名称" class="form-item">
                  <el-input
                    v-model="searchCondition.category_name"
                    placeholder="输入分类名称"
                    clearable
                    prefix-icon="el-icon-collection-tag">
                  </el-input>
                </el-form-item>
                <el-form-item label="是否启用" class="form-item">
                  <el-select
                    v-model="searchCondition.category_status"
                    placeholder="选择状态"
                    clearable>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button type="primary" class="search-btn" @click="loadList()">
                    <i class="el-icon-search"></i>
                    查询
                  </el-button>
                  <el-button class="reset-btn" @click="resetSearch">
                    <i class="el-icon-refresh-left"></i>
                    重置
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-folder-opened"></i>
              问答分类列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{list.length}} 条记录</span>
            </div>
          </div>

          <ApeTable
            :data="list"
            :loading="loadingStaus"
            ref="apeTable"
            highlight-current-row
            class="modern-table">
            <el-table-column
              slot="first-column"
              width="80"
              align="center"
              label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top">
                  <span class="drag-handle" :data-id="scope.row.id">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="分类信息" min-width="220">
              <template slot-scope="scope">
                <div class="category-cell">
                  <div class="category-name">
                    {{scope.row.category_name}}
                  </div>
                  <div class="category-desc" v-if="scope.row.category_desc">
                    {{scope.row.category_desc}}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="scope">
                <div class="status-cell">
                  <el-switch
                    v-model="scope.row.category_status"
                    :active-value="'1'"
                    :inactive-value="'0'"
                    active-color="#67C23A"
                    inactive-color="#F56C6C"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                  <div class="status-text">
                    {{scope.row.category_status === '1' ? '已启用' : '已禁用'}}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="160" align="center">
              <template slot-scope="scope">
                <div class="action-cell">
                  <el-tooltip effect="dark" content="编辑" placement="top">
                    <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-edit"
                      class="table-action-btn edit-btn"
                      @click="editButton(scope.row.id)">
                    </el-button>
                  </el-tooltip>
                  <el-popconfirm
                    title="确定删除该分类及其下所有问答吗？"
                    confirm-button-text="删除"
                    cancel-button-text="取消"
                    @confirm="deleteButton(scope.row.id)">
                    <el-button
                      slot="reference"
                      size="small"
                      type="danger"
                      icon="el-icon-delete"
                      class="table-action-btn delete-btn">
                    </el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="categoryForm" label-position="right" label-width="96px">
          <el-form-item label="名称" prop="category_name">
            <el-input v-model="formData.category_name" placeholder="请输入分类名称"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="category_desc">
            <el-input type="textarea" v-model="formData.category_desc" placeholder="分类描述"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="category_status">
            <el-switch
              v-model="formData.category_status"
              :active-value="'1'"
              :inactive-value="'0'"
              active-text="启用"
              inactive-text="禁用">
            </el-switch>
          </el-form-item>
          <I18nTranslatePanel entity-type="fqa_category" :entity-id="formData.id || ''" />
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import Sortable from 'sortablejs'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    I18nTranslatePanel
  },
  data() {
    return {
      loadingStaus: true,
      dialogData: {
        visible: false,
        title: '',
        width: '28%',
        loading: true,
        modal: false
      },
      searchCondition: {
        current_page: 1,
        page_size: 1000,
        category_name: '',
        category_status: '',
        order_by: 'category_rank asc',
        query: '',
        params: []
      },
      list: [],
      formData: {},
      rules: {
        category_name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      },
      sortable: null
    }
  },
  methods: {
    addButton() {
      this.dialogData.visible = true
      this.dialogData.title = '添加问答分类'
      this.formData = {
        id: '',
        category_name: '',
        category_desc: '',
        category_status: '1'
      }
      this.dialogData.loading = false
    },
    resetSearch() {
      this.searchCondition.category_name = ''
      this.searchCondition.category_status = ''
      this.loadList()
    },
    setSearchCondition() {
      this.searchCondition.params = []
      this.searchCondition.query = ''
      if (this.searchCondition.category_name) {
        this.searchCondition.query = 'INSTR(category_name,?)'
        this.searchCondition.params.push(this.searchCondition.category_name)
      }
      if (this.searchCondition.category_status !== '' && this.searchCondition.category_status != null) {
        if (this.searchCondition.query) {
          this.searchCondition.query += ' and category_status=?'
        } else {
          this.searchCondition.query = 'category_status=?'
        }
        this.searchCondition.params.push(this.searchCondition.category_status)
      }
    },
    async editButton(id) {
      this.dialogData.visible = true
      this.dialogData.title = '编辑问答分类'
      let res = await this.$api.post('/service/ola_app_fqa_category/detail', { id })
      if (this.$apiSuccess(res)) {
        this.formData = res.data.detail
      } else {
        this.$message.error(res.message || '加载失败')
      }
      this.dialogData.loading = false
    },
    async changeStatus(row) {
      let res = await this.$api.post('/service/ola_app_fqa_category/update', row)
      if (this.$apiSuccess(res)) {
        this.$message.success('状态切换成功!')
      } else {
        this.$message.error(res.message || '状态切换失败')
        this.loadList()
      }
    },
    async formSubmit() {
      let url = '/service/ola_app_fqa_category/create'
      if (this.formData.id) {
        url = '/service/ola_app_fqa_category/update'
      }
      let res = await this.$api.post(url, this.formData)
      if (this.$apiSuccess(res)) {
        this.loadList()
        this.dialogClose()
        this.$message.success('保存成功!')
      } else {
        this.$message.error(res.message || '保存失败')
      }
    },
    async loadList() {
      this.loadingStaus = true
      this.setSearchCondition()
      let res = await this.$api.post('/service/ola_app_fqa_category/list', this.searchCondition)
      if (this.$apiSuccess(res)) {
        this.list = res.data.list || []
      } else {
        this.$message.error(res.message || '加载失败')
      }
      this.loadingStaus = false
    },
    async deleteButton(id) {
      let res = await this.$api.post('/service/fqa_category/delete', { id })
      if (this.$apiSuccess(res)) {
        this.loadList()
        this.$message.success('删除成功!')
      } else {
        this.$message.error(res.message || '删除失败!')
      }
    },
    handleConfirm() {
      this.$refs['categoryForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.$nextTick(() => {
        if (this.$refs['categoryForm']) {
          this.$refs['categoryForm'].resetFields()
        }
      })
    },
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_fqa_category/order', {
        orderIds,
        sort_field: 'category_rank'
      })
      if (this.$apiSuccess(res)) {
        this.$message.success('排序成功!')
        this.loadList()
      } else {
        this.$message.error('排序失败!')
      }
    },
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      if (!el) return
      this.sortable = Sortable.create(el, {
        handle: '.drag-handle',
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i = 0, len = tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        }
      })
    }
  },
  async mounted() {
    this.loadList()
    this.$nextTick(() => {
      this.dragSort()
    })
  }
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0

.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0

  .action-buttons
    display flex
    gap 12px

    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500

      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none

.search-card, .table-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0

.search-header, .table-header
  margin-bottom 16px
  padding-bottom 12px
  border-bottom 1px solid #f0f0f0
  display flex
  justify-content space-between
  align-items center

.search-title, .table-title
  font-size 16px
  font-weight 600
  color #303133
  margin 0
  display flex
  align-items center
  gap 8px

  i
    color #409EFF

.data-count
  color #909399
  font-size 14px

.form-row
  display flex
  flex-wrap wrap
  gap 8px
  align-items center

.drag-handle
  font-size 20px
  color #909399
  cursor move

  &:hover
    color #409EFF

.category-cell
  .category-name
    font-size 15px
    font-weight 600
    color #303133

  .category-desc
    margin-top 6px
    color #909399
    font-size 13px

.status-cell
  display flex
  flex-direction column
  align-items center
  gap 6px

  .status-text
    font-size 12px
    color #909399

.action-cell
  display flex
  gap 6px
  justify-content center

  .table-action-btn
    width 28px
    height 28px
    border-radius 6px
    padding 0
</style>
